var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.acreditacoes && Array.isArray(_vm.acreditacoes))?_c('div',{staticClass:"acreditacoes"},[_vm._l((_vm.acreditacoes),function(acreditacao,index){return [(acreditacao)?_c('img',{key:index,attrs:{"src":acreditacao.icone}}):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }